<div
    class="fcp-dropdown"
    [ngClass]="{
        'fcp-dropdown-compact': compact,
        'fcp-dropdown-bordered': bordered,
        'fcp-dropdown-disabled': disabled
    }"
    #container
>
    <div
        class="fcp-dropdown-container"
        (click)="handleClick()"
        [ngClass]="{ 'fcp-dropdown-open': isOpen, 'fcp-dropdown-selected': hasSelection() }"
        [attr.data-e2e-hook]="e2eHook"
    >
        <input
            *ngIf="autoComplete"
            #input
            [value]="searchQuery"
            (keyup)="handleSearchQueryChange(input.value)"
            (keyup.enter)="handleSearchQueryChange(input.value)"
            [placeholder]="placeholder"
            type="text"
            autocapitalize="none"
        />
        <div class="fcp-dropdown-label" *ngIf="!autoComplete">
            <ng-content></ng-content>
            {{ placeholder }}
        </div>
        <ng-container *ngIf="!isMulti && !!asFcpDropdownItem(selected)">
            <div class="fcp-dropdown-badge" *ngIf="asFcpDropdownItem(selected).badgeText">
                <fcp-badge
                    [text]="asFcpDropdownItem(selected).badgeText"
                    [color]="asFcpDropdownItem(selected).badgeColor ?? badgeColor"
                    [inversed]="asFcpDropdownItem(selected).badgeInversed ?? badgeInversed"
                ></fcp-badge>
            </div>
        </ng-container>
        <div class="fcp-dropdown-icon" *ngIf="!autoComplete">
            <ng-container *ngIf="!!icon; else defaultIcon">
                <fcp-icon [icon]="icon" [isCustom]="isCustomIcon"></fcp-icon>
            </ng-container>
            <ng-template #defaultIcon>
                <fcp-icon [icon]="['fal', 'chevron-down']"></fcp-icon>
            </ng-template>
        </div>
    </div>
    <div class="fcp-dropdown-menu" *ngIf="isOpen">
        <div
            class="fcp-dropdown-menu-item"
            *ngFor="let item of items"
            (click)="handleSelect(item)"
            [ngClass]="{
                'fcp-dropdown-menu-item-selected': isSelected(item)
            }"
        >
            <div class="fcp-dropdown-menu-item-icon" *ngIf="item?.icon">
                <fcp-icon [icon]="item.icon" [isCustom]="!!item.isCustomIcon" [style]="item.iconStyle"></fcp-icon>
            </div>
            <div
                class="fcp-dropdown-menu-item-label"
                [ngClass]="{
                    'fcp-dropdown-menu-item-label-colored': item.colored,
                    'fcp-dropdown-menu-item-label-multiline': isMultiLine
                }"
            >
                <span>
                    {{ item.label }}
                    <span *ngIf="isSelected(item) && getSelectionInfo(item.value)"
                        >({{ getSelectionInfo(item.value) }})</span
                    >
                </span>
                <span *ngIf="!!item.description" class="fcp-dropdown-menu-item-label-description">
                    {{ item.description }}
                </span>
            </div>
            <div class="fcp-dropdown-menu-item-badge" *ngIf="item.badgeText">
                <fcp-badge
                    [text]="item.badgeText"
                    [color]="item.badgeColor ?? badgeColor"
                    [inversed]="item.badgeInversed ?? badgeInversed"
                ></fcp-badge>
            </div>
            <div class="fcp-dropdown-menu-selected-icon">
                <fcp-icon
                    *ngIf="isSelected(item)"
                    [icon]="['fal', 'check']"
                    [style]="'color:var(--interactive-13);'"
                ></fcp-icon>
            </div>
        </div>
    </div>
</div>
